$(document).ready(function () {
  let filterByFromQuery = $("body").attr("filter_by") || null;
  let startDateFromQuery = $("body").attr("start_date") || null;
  let endDateFromQuery = $("body").attr("end_date") || null;
  let customPeriodFromQuery = $("body").attr("custom_period") || null;
  let prevSelectedPeriodFromQuery =
    $("body").attr("prev_selected_period") || null;

  if (p === "statistic_coverage_contribution") {
    let totalDG = 0;
    let totalDB = 0;
    let exportDateData = [];
    let exportDGDBData = [];
    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );
    handleCustomerIdChange(getDgAndDb);
    handleCustomPeriodChange(getDgAndDb);
    handleTopProductGroupChange(getDgAndDb);
    handleSupplierIdChange(getDgAndDb);
    handleProductGroupChange(getDgAndDb);
    handleUserChange(getDgAndDb);
    handlePlatformChange(getDgAndDb);
    handlePeriodChange(getDgAndDb);
    handleDateAndTimeChange(getDgAndDb);
    handlePreviousButton(getDgAndDb);
    handleNextButton(getDgAndDb);
    handleCompareByChange(getDgAndDb);
    handleProductChange(getDgAndDb);
    handlePaymentChange(getDgAndDb);
    handleVatCodeChange(getDgAndDb);
    handleLocationChange(getDgAndDb);
    handleCustomDayChange(getDgAndDb);

    $(document).on("click", "#download-statistic-excel", function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        url: "/api/v1/private/statistics/download-statistic-excel",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_dgdb_data: exportDGDBData,
          export_type: "DG_DB",
          total_DG: totalDG,
          total_DB: totalDB,
        }),
        xhrFields: { responseType: "blob" }, // receive binary data
        success: function (data) {
          if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk dekningsbidrag (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).xlsx`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
            const blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk dekningsbidrag (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).xlsx`;
            link.click();
          }
        },
        error: function () {
          alert("Error generating Excel file");
        },
        complete: function () {
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Last ned(excel)");
        },
      });
    });

    $(document).on("click", "#download-statistic-pdf", function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      var svg = chartComponent.getSVG();

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var img = new Image();

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        var pngData = canvas.toDataURL("image/png"); // base64 PNG

        // Send AJAX after PNG is ready
        $.ajax({
          url: "/api/v1/private/statistics/download-statistic-pdf",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify({
            export_date_data: exportDateData,
            export_dgdb_data: exportDGDBData,
            export_type: "DG_DB",
            total_DG: totalDG,
            total_DB: totalDB,
            chart_png: pngData,
          }),
          xhrFields: { responseType: "blob" },
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk dekningsbidrag (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf'
                    }
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: "application/pdf" });
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk dekningsbidrag (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert("Error generating PDF");
            disabledOnClick.prop("disabled", false);
            disabledOnClick.html("Last ned(pdf)");
          },
          complete: function () {
            disabledOnClick.prop("disabled", false);
            disabledOnClick.html("Last ned(pdf)");
          }
        });
      };

      img.src =
        "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
    });

    function eventLineChart(categoryArray, seriesData1, seriesData2) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      // Calculate totals for series
      const total1 = seriesData1.reduce((sum, val) => sum + val, 0);
      const total2 = seriesData2.reduce((sum, val) => sum + val, 0);

      // Render the chart
      chartComponent = Highcharts.chart("event-line-graph", {
        chart: {
          type: "column",
        },
        title: {
          text: null,
        },
        exporting: { enabled: false },
        plotOptions: {
          series: {
            lineWidth: 4,
          },
        },
        xAxis: {
          categories: categoryArray,
          labels: {
            formatter: function () {
              if (customPeriod === "day") {
                return Highcharts.dateFormat(
                  "%e/%b",
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === "week") {
                return "Uke " + this.value;
              } else if (customPeriod === "month") {
                return Highcharts.dateFormat(
                  "%B %Y",
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: "Ordrebeløp",
          },
        },
        series:
          seriesData1.length === 0 && seriesData2.length === 0
            ? [
                {
                  name: "TotalDB",
                  data: categoryArray.map((value) => [value, 0]),
                },
              ]
            : [
                {
                  name: compareBy
                    ? `TotalDB (${formatNumber(total1)}) ${legendText}`
                    : "TotalDB",
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    value,
                  ]),
                },
                {
                  name: compareBy
                    ? `TotalDB forrige ${getPeriodTranslation(
                        compareBy,
                        startDate
                      )} (${formatNumber(total2)}) ${previousLegendText}`
                    : `TotalDB forrige ${getPeriodTranslation(
                        compareBy ?? "",
                        startDate
                      )}`,
                  data: seriesData2.map((value, index) => [
                    categoryArray[index],
                    value,
                  ]),
                },
              ],
        tooltip: {
          formatter: function () {
            var tooltipText;
            if (startDate.split(" ")[0] === endDate.split(" ")[0]) {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%H:%M, %b %e", this.x) +
                "</b><br/>" +
                "TotalDB " +
                formatNumber(this.y);
            } else if (customPeriod === "week") {
              tooltipText =
                "<b>" +
                "Uke" +
                " " +
                this.x +
                "</b><br/>" +
                "TotalDB " +
                formatNumber(this.y);
            } else if (customPeriod === "month") {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%B - %Y", this.x) +
                "</b><br/>" +
                "TotalDB " +
                formatNumber(this.y);
            } else {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%A, %b %e, %Y", this.x) +
                "</b><br/>" +
                "TotalDB " +
                formatNumber(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function getDgAndDb(
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = 'all',
      userId = null,
      platform = "all",
      customPeriod,
      topProductGroupUniqueId = 0,
      customerId = 0,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      selectedDay = null
    ) {
      $.ajax({
        type: "POST",
        url: "/ajax/statistic_coverage_contribution/search",
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          selectedDay,
        },
      })
        .done(function (data) {
          if (data.totalDG && data.totalDB) {
            $("#key-figure-dg").text(parseFloat(data.totalDG));
            $("#key-figure-db").text(parseFloat(data.totalDB));
            totalDG = parseFloat(data.totalDG);
            totalDB = parseFloat(data.totalDB);
          } else {
            $("#key-figure-dg").text("0");
            $("#key-figure-db").text("0");
          }
          if (data.data) {
            const { xAxisArray, seriesData1, seriesData2 } = data.data;
            exportDateData = xAxisArray;
            exportDGDBData = seriesData1;
            eventLineChart(xAxisArray, seriesData1, seriesData2);
          }

          let aTags = $(".statistic-tab-group a");
          aTags.each(function () {
            let oldHref = $(this).attr("href").split("?")[0];
            let newHref =
              oldHref +
              `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
            $(this).prop("href", newHref);
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    getDgAndDb(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod
    );
    toggleCustomDatePicker();
  }
});
